import NotFound from './NotFound'

export default NotFound



// WEBPACK FOOTER //
// ./src/views/NotFound/index.js